// import React from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import ToastService from '../../services/toastService';

// const Sidebar = ({ isOpen, onClose }) => {
//   const navigate = useNavigate();
//   const user = authService.getCurrentUser();

//   const handleLogout = () => {
//     ToastService.info('Logging out...', 'info', 1500);
//     setTimeout(() => {
//       authService.logout();
//     }, 500);
//   };

//   const handleNavigation = (path) => {
//     navigate(path);
//     onClose();
//   };

//   const menuItems = [
//     { path: '/dashboard', icon: 'fas fa-house', label: 'Dashboard', badge: 'NEW' },
//     { path: '/customers', icon: 'fas fa-users', label: 'Customers' },
//     { path: '/stocks', icon: 'fas fa-boxes-stacked', label: 'Stock' },
//     { path: '/credit', icon: 'fas fa-file-invoice-dollar', label: 'Credit Ledger' },
//     { path: '/sales', icon: 'fas fa-chart-line', label: 'View Sales' },
//     { path: '/create-sale', icon: 'fas fa-cart-plus', label: 'Make Sale' },
//     { path: '/collections', icon: 'fas fa-hand-holding-dollar', label: 'Collections' },
//     { path: '/settings', icon: 'fas fa-cog', label: 'Settings' },
//   ];

//   return (
//     <>
//       {/* Mobile Overlay - appears on mobile/tablet when sidebar is open */}
//       <div 
//         className={`fixed inset-0 bg-black bg-opacity-50 z-40 transition-opacity duration-300 lg:hidden ${
//           isOpen ? 'opacity-100 visible' : 'opacity-0 invisible'
//         }`}
//         onClick={onClose}
//       />
      
//       {/* Sidebar */}
//       <aside 
//         className={`fixed top-0 left-0 z-50 h-full w-64 bg-gradient-to-b from-slate-900 to-slate-800 text-white shadow-2xl transform transition-transform duration-300 ease-in-out lg:translate-x-0 lg:static lg:z-auto ${
//           isOpen ? 'translate-x-0' : '-translate-x-full'
//         }`}
//       >
//         {/* Header */}
//         <div className="flex items-center justify-between px-4 py-5 border-b border-slate-700">
//           <div className="flex items-center gap-3">
//             {/* <div className="w-10 h-10 bg-gradient-to-br from-blue-500 to-blue-600 rounded-lg flex items-center justify-center font-bold text-sm shadow-lg">
             
//             </div> */}
//             <div className="flex-1 min-w-0">
//               <h1 className="text-base font-bold text-white truncate text-2.5xl">Sales Management</h1>
//             </div>
//           </div>
//           <button 
//             className="lg:hidden w-8 h-8 flex items-center justify-center rounded-lg hover:bg-slate-700 transition-colors"
//             onClick={onClose}
//           >
//             <i className="fas fa-times text-slate-400"></i>
//           </button>
//         </div>
        
//         {/* Menu Items */}
//         <div className="flex flex-col h-[calc(100%-81px)] overflow-y-auto">
//           <nav className="flex-1 px-3 py-4">
//             <ul className="space-y-1">
//               {menuItems.map((item) => (
//                 <li key={item.path}>
//                   <NavLink 
//                     to={item.path}
//                     onClick={() => handleNavigation(item.path)}
//                     className={({ isActive }) => `
//                       group flex items-center gap-3 px-3 py-2.5 rounded-lg transition-all duration-200
//                       ${isActive 
//                         ? 'bg-blue-600 text-white shadow-lg shadow-blue-600/50' 
//                         : 'text-slate-300 hover:bg-slate-700/50 hover:text-white'
//                       }
//                     `}
//                   >
//                     <div className="w-5 flex items-center justify-center">
//                       <i className={`${item.icon} text-sm`}></i>
//                     </div>
//                     <span className="flex-1 text-sm font-medium">{item.label}</span>
//                     {item.badge && (
//                       <span className="px-2 py-0.5 text-[10px] font-bold bg-green-500 text-white rounded-full">
//                         {item.badge}
//                       </span>
//                     )}
//                   </NavLink>
//                 </li>
//               ))}
//             </ul>
//           </nav>
          
//           {/* Logout Button */}
//           <div className="px-3 py-4 border-t border-slate-700">
//             <button 
//               className="group w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-slate-300 hover:bg-red-600/20 hover:text-red-400 transition-all duration-200"
//               onClick={handleLogout}
//             >
//               <div className="w-5 flex items-center justify-center">
//                 <i className="fas fa-right-from-bracket text-sm"></i>
//               </div>
//               <span className="flex-1 text-sm font-medium text-left">Logout</span>
//             </button>
//           </div>
//         </div>
//       </aside>
//     </>
//   );
// };

// export default Sidebar;


// import React from 'react';
// import { NavLink, useNavigate } from 'react-router-dom';
// import authService from '../../services/authService';
// import ToastService from '../../services/toastService';

// /* ════════════════════════════════════
//    INLINE SVG ICONS — no dependencies
// ════════════════════════════════════ */
// const Ic = ({ children, size = 14 }) => (
//   <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
//     stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
//     {children}
//   </svg>
// );

// /* Dashboard — 4-square grid */
// const IcDashboard = () => (
//   <Ic>
//     <rect x="3" y="3" width="7" height="7" rx="1.5" />
//     <rect x="14" y="3" width="7" height="7" rx="1.5" />
//     <rect x="3" y="14" width="7" height="7" rx="1.5" />
//     <rect x="14" y="14" width="7" height="7" rx="1.5" />
//   </Ic>
// );

// /* Customers — people group */
// const IcCustomers = () => (
//   <Ic>
//     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//     <circle cx="9" cy="7" r="4" />
//     <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//     <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//   </Ic>
// );

// /* Stock — 3D box / package */
// const IcStock = () => (
//   <Ic>
//     <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
//     <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
//     <line x1="12" y1="22.08" x2="12" y2="12" />
//   </Ic>
// );

// /* Credit Ledger — document with dollar lines */
// const IcCredit = () => (
//   <Ic>
//     <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
//     <polyline points="14 2 14 8 20 8" />
//     <line x1="12" y1="12" x2="12" y2="18" />
//     <line x1="9" y1="14" x2="15" y2="14" />
//     <line x1="9.5" y1="11.5" x2="14.5" y2="11.5" />
//   </Ic>
// );

// /* View Sales — bar chart */
// const IcSales = () => (
//   <Ic>
//     <line x1="18" y1="20" x2="18" y2="10" />
//     <line x1="12" y1="20" x2="12" y2="4" />
//     <line x1="6" y1="20" x2="6" y2="14" />
//     <line x1="2" y1="20" x2="22" y2="20" />
//   </Ic>
// );

// /* Make Sale — shopping cart with plus */
// const IcMakeSale = () => (
//   <Ic>
//     <circle cx="9" cy="21" r="1" />
//     <circle cx="20" cy="21" r="1" />
//     <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
//     <line x1="16" y1="11" x2="16" y2="17" />
//     <line x1="13" y1="14" x2="19" y2="14" />
//   </Ic>
// );

// /* Collections — credit card / wallet */
// const IcCollections = () => (
//   <Ic>
//     <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
//     <line x1="1" y1="10" x2="23" y2="10" />
//     <line x1="6" y1="15" x2="10" y2="15" />
//   </Ic>
// );

// /* Settings — cog */
// const IcSettings = () => (
//   <Ic>
//     <circle cx="12" cy="12" r="3" />
//     <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
//   </Ic>
// );

// /* Logout — door with arrow */
// const IcLogout = () => (
//   <Ic>
//     <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
//     <polyline points="16 17 21 12 16 7" />
//     <line x1="21" y1="12" x2="9" y2="12" />
//   </Ic>
// );

// /* Close X */
// const IcClose = () => (
//   <Ic size={13}>
//     <line x1="18" y1="6" x2="6" y2="18" />
//     <line x1="6" y1="6" x2="18" y2="18" />
//   </Ic>
// );

// /* Brand icon */
// const IcBrand = () => (
//   <Ic size={16}>
//     <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
//     <circle cx="9" cy="7" r="4" />
//     <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
//     <path d="M16 3.13a4 4 0 0 1 0 7.75" />
//   </Ic>
// );

// /* ════════════════════════════════════
//    SIDEBAR COMPONENT
// ════════════════════════════════════ */
// const Sidebar = ({ isOpen, onClose }) => {
//   const navigate = useNavigate();
//   const user     = authService.getCurrentUser();

//   const handleLogout = () => {
//     ToastService.info('Logging out...', 'info', 1500);
//     setTimeout(() => { authService.logout(); }, 500);
//   };

//   const handleNavigation = (path) => {
//     navigate(path);
//     onClose();
//   };

//   const menuItems = [
//     { path: '/dashboard',   label: 'Dashboard',     icon: <IcDashboard />,},
//     { path: '/customers',   label: 'Customers',     icon: <IcCustomers /> },
//     { path: '/stocks',      label: 'Stock',         icon: <IcStock /> },
//     { path: '/credit',      label: 'Credit Ledger', icon: <IcCredit /> },
//     { path: '/sales',       label: 'View Sales',    icon: <IcSales /> },
//     { path: '/create-sale', label: 'Make Sale',     icon: <IcMakeSale /> },
//     { path: '/collections', label: 'Collections',   icon: <IcCollections /> },
//     { path: '/settings',    label: 'Settings',      icon: <IcSettings /> },
//   ];

//   return (
//     <>
//       {/* ── Fonts ── */}
//       <style>{`
//         @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Lora:wght@600;700&display=swap');
//         .sb-body  { font-family: 'Outfit', sans-serif; -webkit-font-smoothing: antialiased; }
//         .sb-serif { font-family: 'Lora', serif; }
//       `}</style>

//       {/* ── Mobile overlay ── */}
//       <div
//         className={`
//           fixed inset-0 z-40 bg-[#0b1d17]/45 backdrop-blur-sm
//           transition-opacity duration-300 lg:hidden
//           ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}
//         `}
//         onClick={onClose}
//       />

//       {/* ════════════════════════════════════
//           SIDEBAR PANEL
//       ════════════════════════════════════ */}
//       <aside
//         className={`
//           sb-body
//           fixed top-0 left-0 z-50 h-full w-[264px]
//           bg-white border-r border-[#d0e8e0]
//           shadow-[4px_0_20px_rgba(11,29,23,0.07)]
//           flex flex-col
//           transform transition-transform duration-300 ease-in-out
//           lg:translate-x-0 lg:static lg:z-auto
//           ${isOpen ? 'translate-x-0' : '-translate-x-full'}
//         `}
//       >

//         {/* ── HEADER ── */}
//         <div className="flex items-center justify-between px-4 py-4 border-b border-[#d0e8e0] flex-shrink-0">
//           <div className="flex items-center gap-3 min-w-0">
//             <div className="w-9 h-9 rounded-xl bg-[#0f6652] flex items-center justify-center flex-shrink-0 text-white shadow-[0_2px_10px_rgba(15,102,82,0.28)]">
//               <IcBrand />
//             </div>
//             <div className="min-w-0">
//               <p className="sb-serif text-[14.5px] font-bold text-[#0b1d17] leading-tight tracking-[-0.2px] truncate">
//                 Sales App Lite
//               </p>
//               <p className="text-[11px] text-[#4f7a6d] font-medium mt-0.5 truncate">
//                 Sales Management
//               </p>
//             </div>
//           </div>

//           {/* Close btn — mobile only */}
//           <button
//             className="lg:hidden w-7 h-7 rounded-lg bg-[#edf9f5] border border-[#d0e8e0] text-[#4f7a6d] hover:bg-[#d6f2ea] hover:text-[#0f6652] flex items-center justify-center transition-colors flex-shrink-0 ml-2"
//             onClick={onClose}
//             aria-label="Close sidebar"
//           >
//             <IcClose />
//           </button>
//         </div>

//         {/* ── USER CARD ── */}
//         {user && (
//           <div className="mx-3 mt-3.5 px-3.5 py-3 rounded-xl bg-[#edf9f5] border border-[#c0dfd8] flex items-center gap-3 flex-shrink-0">
//             <div className="w-8 h-8 rounded-full bg-[#1A8A6E] flex items-center justify-center flex-shrink-0 text-white text-[12px] font-bold shadow-[0_1px_6px_rgba(26,138,110,0.25)]">
//               {(user.firstName?.[0] || user.username?.[0] || 'U').toUpperCase()}
//             </div>
//             <div className="min-w-0 flex-1">
//               <p className="text-[13px] font-semibold text-[#0b1d17] truncate leading-tight">
//                 {user.firstName
//                   ? `${user.firstName} ${user.lastName || ''}`.trim()
//                   : user.username || 'User'}
//               </p>
//               <p className="text-[11px] text-[#4f7a6d] font-medium truncate mt-0.5">
//                 {user.role || 'Sales Rep'}
//               </p>
//             </div>
//           </div>
//         )}

//         {/* ── NAV LABEL ── */}
//         <p className="px-5 pt-4 pb-1.5 text-[10px] font-bold uppercase tracking-[0.8px] text-[#8fb8ae]">
//           Menu
//         </p>

//         {/* ── NAV ITEMS ── */}
//         <nav className="flex-1 px-3 overflow-y-auto overscroll-contain">
//           <ul className="space-y-0.5 pb-4">
//             {menuItems.map((item) => (
//               <li key={item.path}>
//                 <NavLink
//                   to={item.path}
//                   onClick={() => handleNavigation(item.path)}
//                   className={({ isActive }) =>
//                     `group flex items-center gap-3 px-3 py-2.5 rounded-xl border min-h-[44px] transition-all duration-200 ${
//                       isActive
//                         ? 'bg-[#edf9f5] border-[#c0dfd8]'
//                         : 'border-transparent hover:bg-[#f4f9f7] hover:border-[#e4f2ed]'
//                     }`
//                   }
//                 >
//                   {({ isActive }) => (
//                     <>
//                       {/* Icon box */}
//                       <div
//                         className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
//                           isActive
//                             ? 'bg-[#1A8A6E] text-white shadow-[0_2px_8px_rgba(26,138,110,0.28)]'
//                             : 'bg-[#edf9f5] text-[#1A8A6E] group-hover:bg-[#d6f2ea]'
//                         }`}
//                       >
//                         {item.icon}
//                       </div>

//                       {/* Label */}
//                       <span
//                         className={`flex-1 text-[13.5px] tracking-[-0.1px] transition-colors duration-200 ${
//                           isActive
//                             ? 'font-bold text-[#0f6652]'
//                             : 'font-semibold text-[#1e4037] group-hover:text-[#0f6652]'
//                         }`}
//                       >
//                         {item.label}
//                       </span>

//                       {/* Badge */}
//                       {item.badge && (
//                         <span className="px-1.5 py-0.5 text-[9px] font-bold rounded-md bg-[#1A8A6E] text-white tracking-wide">
//                           {item.badge}
//                         </span>
//                       )}

//                       {/* Active indicator */}
//                       {isActive && (
//                         <div className="w-1 h-5 rounded-full bg-[#1A8A6E] flex-shrink-0" />
//                       )}
//                     </>
//                   )}
//                 </NavLink>
//               </li>
//             ))}
//           </ul>
//         </nav>

//         {/* ── FOOTER / LOGOUT ── */}
//         <div className="flex-shrink-0 px-3 pt-2 pb-5 border-t border-[#d0e8e0]">
//           <div className="px-3 mb-1.5 flex items-center justify-between">
//             <span className="text-[10px] text-[#8fb8ae] font-medium">Sales App Lite</span>
//             <span className="text-[10px] text-[#c2dcd7]">v1.0.0</span>
//           </div>

//           <button
//             className="group w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border border-transparent hover:bg-red-50 hover:border-red-100 transition-all duration-200 min-h-[44px]"
//             onClick={handleLogout}
//           >
//             <div className="w-7 h-7 rounded-lg bg-[#edf9f5] text-[#1A8A6E] group-hover:bg-red-100 group-hover:text-red-500 flex items-center justify-center flex-shrink-0 transition-all duration-200">
//               <IcLogout />
//             </div>
//             <span className="flex-1 text-[13.5px] font-semibold text-left text-[#1e4037] group-hover:text-red-500 tracking-[-0.1px] transition-colors duration-200">
//               Logout
//             </span>
//           </button>
//         </div>

//       </aside>
//     </>
//   );
// };

// export default Sidebar;

import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import authService from '../../services/authService';
import ToastService from '../../services/toastService';
import { BUSINESS_NAME, VERSION } from '../../utils/config';


/* ════════════════════════════════════
   INLINE SVG ICONS — no dependencies
════════════════════════════════════ */
const Ic = ({ children, size = 14 }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    {children}
  </svg>
);

/* Dashboard — 4-square grid */
const IcDashboard = () => (
  <Ic>
    <rect x="3" y="3" width="7" height="7" rx="1.5" />
    <rect x="14" y="3" width="7" height="7" rx="1.5" />
    <rect x="3" y="14" width="7" height="7" rx="1.5" />
    <rect x="14" y="14" width="7" height="7" rx="1.5" />
  </Ic>
);

/* Customers — people group */
const IcCustomers = () => (
  <Ic>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </Ic>
);

/* Stock — 3D box / package */
const IcStock = () => (
  <Ic>
    <path d="M21 16V8a2 2 0 0 0-1-1.73l-7-4a2 2 0 0 0-2 0l-7 4A2 2 0 0 0 3 8v8a2 2 0 0 0 1 1.73l7 4a2 2 0 0 0 2 0l7-4A2 2 0 0 0 21 16z" />
    <polyline points="3.27 6.96 12 12.01 20.73 6.96" />
    <line x1="12" y1="22.08" x2="12" y2="12" />
  </Ic>
);

/* Credit Ledger — document with dollar lines */
const IcCredit = () => (
  <Ic>
    <path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z" />
    <polyline points="14 2 14 8 20 8" />
    <line x1="12" y1="12" x2="12" y2="18" />
    <line x1="9" y1="14" x2="15" y2="14" />
    <line x1="9.5" y1="11.5" x2="14.5" y2="11.5" />
  </Ic>
);

/* View Sales — bar chart */
const IcSales = () => (
  <Ic>
    <line x1="18" y1="20" x2="18" y2="10" />
    <line x1="12" y1="20" x2="12" y2="4" />
    <line x1="6" y1="20" x2="6" y2="14" />
    <line x1="2" y1="20" x2="22" y2="20" />
  </Ic>
);

/* Make Sale — shopping cart with plus */
const IcMakeSale = () => (
  <Ic>
    <circle cx="9" cy="21" r="1" />
    <circle cx="20" cy="21" r="1" />
    <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    <line x1="16" y1="11" x2="16" y2="17" />
    <line x1="13" y1="14" x2="19" y2="14" />
  </Ic>
);

/* Collections — credit card / wallet */
const IcCollections = () => (
  <Ic>
    <rect x="1" y="4" width="22" height="16" rx="2" ry="2" />
    <line x1="1" y1="10" x2="23" y2="10" />
    <line x1="6" y1="15" x2="10" y2="15" />
  </Ic>
);

/* Settings — cog */
const IcSettings = () => (
  <Ic>
    <circle cx="12" cy="12" r="3" />
    <path d="M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 0 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 0 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.68 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 0 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.68a1.65 1.65 0 0 0 1-1.51V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 0 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1z" />
  </Ic>
);

/* Logout — door with arrow */
const IcLogout = () => (
  <Ic>
    <path d="M9 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h4" />
    <polyline points="16 17 21 12 16 7" />
    <line x1="21" y1="12" x2="9" y2="12" />
  </Ic>
);

/* Close X */
const IcClose = () => (
  <Ic size={13}>
    <line x1="18" y1="6" x2="6" y2="18" />
    <line x1="6" y1="6" x2="18" y2="18" />
  </Ic>
);

/* Brand icon */
const IcBrand = () => (
  <Ic size={16}>
    <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
    <circle cx="9" cy="7" r="4" />
    <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
    <path d="M16 3.13a4 4 0 0 1 0 7.75" />
  </Ic>
);

/* ════════════════════════════════════
   SIDEBAR COMPONENT
════════════════════════════════════ */
const Sidebar = ({ isOpen, onClose }) => {
  const navigate = useNavigate();
  const user     = authService.getCurrentUser();

  const handleLogout = () => {
    ToastService.info('Logging out...', 'info', 1500);
    setTimeout(() => { authService.logout(); }, 500);
  };

  const handleNavigation = (path) => {
    navigate(path);
    onClose();
  };

  const menuItems = [
    { path: '/dashboard',   label: 'Dashboard',     icon: <IcDashboard /> },
    { path: '/customers',   label: 'Customers',     icon: <IcCustomers /> },
    { path: '/stocks',      label: 'Stock',         icon: <IcStock /> },
    { path: '/credit',      label: 'Credit Ledger', icon: <IcCredit /> },
    { path: '/sales',       label: 'View Sales',    icon: <IcSales /> },
    { path: '/create-sale', label: 'Make Sale',     icon: <IcMakeSale /> },
    { path: '/collections', label: 'Collections',   icon: <IcCollections /> },
    { path: '/settings',    label: 'Settings',      icon: <IcSettings /> },
  ];

  return (
    <>
      {/* ── Fonts ── */}
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&family=Lora:wght@600;700&display=swap');
        .sb-body  { font-family: 'Outfit', sans-serif; -webkit-font-smoothing: antialiased; }
        .sb-serif { font-family: 'Lora', serif; }
      `}</style>

      {/* ── Mobile overlay ── */}
      <div
        className={`
          fixed inset-0 z-40 bg-[#060b4d]/45 backdrop-blur-sm
          transition-opacity duration-300 lg:hidden
          ${isOpen ? 'opacity-100 visible' : 'opacity-0 invisible pointer-events-none'}
        `}
        onClick={onClose}
      />

      {/* ════════════════════════════════════
          SIDEBAR PANEL
      ════════════════════════════════════ */}
      <aside
        className={`
          sb-body
          fixed top-0 left-0 z-50 h-full w-[264px]
          bg-white border-r border-[#c8cbf0]
          shadow-[4px_0_20px_rgba(6,11,77,0.07)]
          flex flex-col
          transform transition-transform duration-300 ease-in-out
          lg:translate-x-0 lg:static lg:z-auto
          ${isOpen ? 'translate-x-0' : '-translate-x-full'}
        `}
      >

        {/* ── HEADER ── */}
        <div className="flex items-center justify-between px-4 py-4 border-b border-[#c8cbf0] flex-shrink-0">
          <div className="flex items-center gap-3 min-w-0">
            <div className="w-9 h-9 rounded-xl bg-[#040e99] flex items-center justify-center flex-shrink-0 text-white shadow-[0_2px_10px_rgba(4,14,153,0.28)]">
              <IcBrand />
            </div>
            <div className="min-w-0">
              <p className="sb-serif text-[14.5px] font-bold text-[#060b4d] leading-tight tracking-[-0.2px] truncate">
                {BUSINESS_NAME}
              </p>
              <p className="text-[11px] text-[#4a4d99] font-medium mt-0.5 truncate">
                Sales Management
              </p>
            </div>
          </div>

          {/* Close btn — mobile only */}
          <button
            className="lg:hidden w-7 h-7 rounded-lg bg-[#f0f1ff] border border-[#c8cbf0] text-[#4a4d99] hover:bg-[#d8dbff] hover:text-[#040e99] flex items-center justify-center transition-colors flex-shrink-0 ml-2"
            onClick={onClose}
            aria-label="Close sidebar"
          >
            <IcClose />
          </button>
        </div>

        {/* ── USER CARD ── */}
        {user && (
          <div className="mx-3 mt-3.5 px-3.5 py-3 rounded-xl bg-[#f0f1ff] border border-[#b8bcf5] flex items-center gap-3 flex-shrink-0">
            <div className="w-8 h-8 rounded-full bg-[#0613cc] flex items-center justify-center flex-shrink-0 text-white text-[12px] font-bold shadow-[0_1px_6px_rgba(6,19,204,0.25)]">
              {(user.firstName?.[0] || user.username?.[0] || 'U').toUpperCase()}
            </div>
            <div className="min-w-0 flex-1">
              <p className="text-[13px] font-semibold text-[#060b4d] truncate leading-tight">
                {user.firstName
                  ? `${user.firstName} ${user.lastName || ''}`.trim()
                  : user.username || 'User'}
              </p>
              <p className="text-[11px] text-[#4a4d99] font-medium truncate mt-0.5">
                {user.role || 'Sales Rep'}
              </p>
            </div>
          </div>
        )}

        {/* ── NAV LABEL ── */}
        <p className="px-5 pt-4 pb-1.5 text-[10px] font-bold uppercase tracking-[0.8px] text-[#8a8dc9]">
          Menu
        </p>

        {/* ── NAV ITEMS ── */}
        <nav className="flex-1 px-3 overflow-y-auto overscroll-contain">
          <ul className="space-y-0.5 pb-4">
            {menuItems.map((item) => (
              <li key={item.path}>
                <NavLink
                  to={item.path}
                  onClick={() => handleNavigation(item.path)}
                  className={({ isActive }) =>
                    `group flex items-center gap-3 px-3 py-2.5 rounded-xl border min-h-[44px] transition-all duration-200 ${
                      isActive
                        ? 'bg-[#f0f1ff] border-[#b8bcf5]'
                        : 'border-transparent hover:bg-[#f5f5ff] hover:border-[#e4e5f9]'
                    }`
                  }
                >
                  {({ isActive }) => (
                    <>
                      {/* Icon box */}
                      <div
                        className={`w-7 h-7 rounded-lg flex items-center justify-center flex-shrink-0 transition-all duration-200 ${
                          isActive
                            ? 'bg-[#0613cc] text-white shadow-[0_2px_8px_rgba(6,19,204,0.28)]'
                            : 'bg-[#f0f1ff] text-[#0613cc] group-hover:bg-[#d8dbff]'
                        }`}
                      >
                        {item.icon}
                      </div>

                      {/* Label */}
                      <span
                        className={`flex-1 text-[13.5px] tracking-[-0.1px] transition-colors duration-200 ${
                          isActive
                            ? 'font-bold text-[#040e99]'
                            : 'font-semibold text-[#0e1466] group-hover:text-[#040e99]'
                        }`}
                      >
                        {item.label}
                      </span>

                      {/* Badge */}
                      {item.badge && (
                        <span className="px-1.5 py-0.5 text-[9px] font-bold rounded-md bg-[#0613cc] text-white tracking-wide">
                          {item.badge}
                        </span>
                      )}

                      {/* Active indicator */}
                      {isActive && (
                        <div className="w-1 h-5 rounded-full bg-[#0613cc] flex-shrink-0" />
                      )}
                    </>
                  )}
                </NavLink>
              </li>
            ))}
          </ul>
        </nav>

        {/* ── FOOTER / LOGOUT ── */}
        <div className="flex-shrink-0 px-3 pt-2 pb-5 border-t border-[#c8cbf0]">
          <div className="px-3 mb-1.5 flex items-center justify-between">
            <span className="text-[10px] text-[#8a8dc9] font-medium">{BUSINESS_NAME}</span>
            <span className="text-[10px] text-[#c8cbf0]">v{VERSION}</span>
          </div>

          <button
            className="group w-full flex items-center gap-3 px-3 py-2.5 rounded-xl border border-transparent hover:bg-red-50 hover:border-red-100 transition-all duration-200 min-h-[44px]"
            onClick={handleLogout}
          >
            <div className="w-7 h-7 rounded-lg bg-[#f0f1ff] text-[#0613cc] group-hover:bg-red-100 group-hover:text-red-500 flex items-center justify-center flex-shrink-0 transition-all duration-200">
              <IcLogout />
            </div>
            <span className="flex-1 text-[13.5px] font-semibold text-left text-[#0e1466] group-hover:text-red-500 tracking-[-0.1px] transition-colors duration-200">
              Logout
            </span>
          </button>
        </div>

      </aside>
    </>
  );
};

export default Sidebar;